import React from 'react'
import './index.css'

const AddUserButton = ({ customClass, onClick, name }) => {
    return (
        <div id='addUserBlock'>
            <div className={`addUser ${customClass ? customClass : ''}`} onClick={onClick}><span className='addIcon'>
                +</span> {name || 'Add User'} </div>
        </div>
    )
}

export default AddUserButton;